import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { CaseQuickComponent } from './pages/case-quick/case-quick.component';
import { CaseDetailedGeneralComponent } from './pages/case-detailed-general/case-detailed-general.component';
import { QuickProcessingSwitchesComponent } from './components/quick-processing-switches/quick-processing-switches.component';
import { CaseNavigationComponent } from './components/case-navigation/case-navigation.component';
import { CaseDetailedParticipantsComponent } from './pages/case-detailed-participants/case-detailed-participants.component';
import { CaseDetailedVehicleComponent } from './pages/case-detailed-vehicle/case-detailed-vehicle.component';
import { CaseDetailedAccidentDescriptionComponent } from './pages/case-detailed-accident-description/case-detailed-accident-description.component';
import { CaseDetailedAccidentOpponentComponent } from './pages/case-detailed-accident-opponent/case-detailed-accident-opponent.component';
import { CaseDetailedAttachmentsComponent } from './pages/case-detailed-attachments/case-detailed-attachments.component';
import { CaseDetailedDistributionComponent } from './pages/case-detailed-distribution/case-detailed-distribution.component';
import { CaseRoutingModule } from '@app/modules/case/case.routing';
import { CaseEditDetailsComponent } from './components/case-edit-details/case-edit-details.component';
import { VehicleTypeManufacturerSelectComponent } from '@app/modules/case/components/vehicle-type-manufacturer-select/vehicle-type-manufacturer-select.component';
import { MileageComponent } from './components/mileage/mileage.component';
import { VinComponent } from './components/vin/vin.component';
import { VinInputDirective } from '@app/modules/case/components/vin/vin.directive';
import { KbaComponent } from './components/kba/kba.component';
import { AddressParticipantComponent } from './components/address-participant/address-participant.component';
import { CaseFilesUploadComponent } from '@app/modules/case/components/case-files-upload/case-files-upload.component';
import { CaseFilesListComponent } from '@app/modules/case/components/case-files-list/case-files-list.component';
import { CaseFilesThumbnailsListComponent } from './components/case-files-thumbnails-list/case-files-thumbnails-list.component';
import { QuickDetailedSwitchComponent } from './components/quick-detailed-switch/quick-detailed-switch.component';
import { DamageAreaSelectorComponent } from './components/damage-area-selector/damage-area-selector.component';
import { ParticipantDetailsComponent } from './components/participant-details/participant-details.component';
import { CaseDetailedResultsComponent } from '@app/modules/case/pages/case-detailed-results/case-detailed-results.component';
import { CaseResultsEditableComponent } from '@app/modules/case/components/case-results/editable/case-results-editable.component';
import { CaseResultsReadonlyComponent } from '@app/modules/case/components/case-results/readonly/case-results-readonly.component';
import { ResultsFurtherComponent } from '@app/modules/case/components/case-results/further/results-further.component';
import { ResultGraphicComponent } from '@app/modules/case/components/result-graphic/result-graphic.component';
import { InSignSMSDistributionDialogComponent } from '@app/shared/components/distribution-job/insign-sms-distribution-dialog/insign-sms-distribution-dialog.component';
import { InSignEmailDistributionDialogComponent } from '@app/shared/components/distribution-job/insign-email-distribution-dialog/insign-email-distribution-dialog.component';
import { CaseDetailedLawyerComponent } from '@app/modules/case/pages/case-detailed-lawyer/case-detailed-lawyer.component';
import { CaseLawyerEditableComponent } from '@app/modules/case/components/case-lawyer/editable/case-lawyer-editable.component';
import { CaseLawyerReadonlyComponent } from '@app/modules/case/components/case-lawyer/readonly/case-lawyer-readonly.component';
import { CaseLawyerPaymentComponent } from './components/case-lawyer-payment/case-lawyer-payment.component';
import { CaseLawyerPaymentLineEditableComponent } from './components/case-lawyer-payment/editable/case-lawyer-payment-line-editable.component';
import { CaseLawyerPaymentLineReadonlyComponent } from './components/case-lawyer-payment/readonly/case-lawyer-payment-line-readonly.component';
import { CaseCreationDialogComponent } from '@app/modules/case/components/case-creation-dialog/case-creation-dialog.component';
import { CaseDetailedSummaryComponent } from '@app/modules/case/pages/case-detailed-summary/case-detailed-summary.component';
import { CaseSummaryComponent } from '@app/modules/case/components/case-summary/case-summary.component';
import { PaymentDialogComponent } from '@app/modules/case/components/payment-dialog/payment-dialog.component';
import { CaseNumberDialogComponent } from '@app/modules/case/components/case-number-dialog/case-number-dialog.component';



@NgModule({
  declarations: [
    AddressParticipantComponent,
    CaseDetailedGeneralComponent,
    CaseDetailedAccidentDescriptionComponent,
    CaseDetailedAccidentOpponentComponent,
    CaseDetailedAttachmentsComponent,
    CaseDetailedDistributionComponent,
    CaseDetailedLawyerComponent,
    CaseDetailedParticipantsComponent,
    CaseDetailedResultsComponent,
    CaseDetailedSummaryComponent,
    CaseDetailedVehicleComponent,
    CaseEditDetailsComponent,
    CaseFilesListComponent,
    CaseFilesUploadComponent,
    CaseFilesThumbnailsListComponent,
    CaseLawyerEditableComponent,
    CaseLawyerReadonlyComponent,
    CaseLawyerPaymentComponent,
    CaseLawyerPaymentLineEditableComponent,
    CaseLawyerPaymentLineReadonlyComponent,
    CaseNavigationComponent,
    CaseNumberDialogComponent,
    CaseQuickComponent,
    CaseResultsEditableComponent,
    CaseResultsReadonlyComponent,
    CaseSummaryComponent,
    DamageAreaSelectorComponent,
    InSignEmailDistributionDialogComponent,
    InSignSMSDistributionDialogComponent,
    KbaComponent,
    MileageComponent,
    CaseCreationDialogComponent,
    ParticipantDetailsComponent,
    PaymentDialogComponent,
    ResultGraphicComponent,
    ResultsFurtherComponent,
    QuickDetailedSwitchComponent,
    QuickProcessingSwitchesComponent,
    VehicleTypeManufacturerSelectComponent,
    VinComponent,
    VinInputDirective
  ],
  imports: [
    CommonModule,
    SharedModule,
    CaseRoutingModule
  ]
})
export class CaseModule { }
